import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ecp-ui-lib',
  template: `
    <p>
      ecp-ui-lib works!
    </p>
  `,
  styles: []
})
export class EcpUiLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
